module.exports = __webpack_public_path__ + "c42afb28c9285cd28af780e5666a0b7e.svg";